import PropTypes from 'prop-types'
import { InputWithIcon } from '@/components/input-with-icon'
import { Icons } from '@/theme/Images'

const InputBlock = ({
  label,
  icon,
  iconPosition,
  id,
  placeholder,
  autoComplete,
  formik,
  onChange,
  description,
  className,
  showValidation = true,
  ...props
}) => {
  const { onChange: formikOnChange, ...formikProps } = formik.getFieldProps(id)

  // Merge the onChange handlers if both are provided
  const handleChange = e => {
    formikOnChange(e) // Call Formik's onChange
    if (onChange) onChange(e) // Call the passed onChange handler
  }
  const hasError = formik.errors[id] && formik.touched[id]

  return (
    <InputWithIcon
      icon={hasError ? <Icons.FailureAlertIconSimple /> : icon}
      iconPosition={iconPosition}
      label={label}
      id={id}
      placeholder={placeholder}
      autoComplete={autoComplete}
      className={className}
      hasError={hasError}
      helpText={
        showValidation && formik.errors[id] && formik.touched[id] ? (
          <p className="text-sm font-normal text-[--error-500]">{formik.errors[id]}</p>
        ) : null
      }
      fieldDescription={description}
      onChange={handleChange} // Use the merged onChange handler
      {...formikProps}
      {...props}
    />
  )
}

InputBlock.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.node,
  iconPosition: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  formik: PropTypes.object,
  tooltip: PropTypes.node,
  onChange: PropTypes.func,
  description: PropTypes.string,
  showValidation: PropTypes.bool,
}

const TwoColumnContainer = ({ children }) => {
  return <div className="flex sm:flex-row flex-col sm:gap-8 gap-6">{children}</div>
}

TwoColumnContainer.propTypes = {
  children: PropTypes.node,
}
export default InputBlock
